import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {UserRemote} from "@app/core/user/domain/user.remote";

@Injectable({
    providedIn: "root",
})

export class ResetPasswordUseCase {

    constructor(private webService:UserRemote) {}

    execute(email:string, recaptchaToken: string): Observable<void> {
        return this.webService.resetPassword(email, recaptchaToken);
    }
}
